<template>
  <section
    class="pages-path d-flex mt-2 mt-lg-4 align-items-baseline fontsize12 text-black py-2"
  >
    <ul
      class="container content-pagePath d-flex align-items-center box-shaddow20 bg-white text-right"
    >
      <li v-if="isHome">
        <router-link to="/" class="d-flex align-items-center" style="gap: 8px">
          <span class="d-flex -translate-y-1">
            <svg
              width="20"
              height="20"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.9258 4.38469L9.32578 1.79373C8.34453 1.08652 6.83828 1.1251 5.89453 1.87731L2.76328 4.39111C2.13828 4.89259 1.64453 5.92126 1.64453 6.73133V11.1675C1.64453 12.8069 2.93828 14.1442 4.53203 14.1442H11.2695C12.8633 14.1442 14.157 12.8133 14.157 11.1739V6.81491C14.157 5.94697 13.6133 4.87973 12.9258 4.38469ZM8.36953 11.5725C8.36953 11.8361 8.15703 12.0547 7.90078 12.0547C7.64453 12.0547 7.43203 11.8361 7.43203 11.5725V9.64375C7.43203 9.38015 7.64453 9.16156 7.90078 9.16156C8.15703 9.16156 8.36953 9.38015 8.36953 9.64375V11.5725Z"
                fill="#999999"
              />
            </svg>
          </span>
          <span class="fontsize-mini text-black">خانه</span>
          <span class="d-flex" style="transform: translateY(-1px)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="11"
              fill="black"
              class="bi bi-chevron-double-left"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              />
              <path
                fill-rule="evenodd"
                d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              />
            </svg>
          </span>
        </router-link>
      </li>
      <template v-if="list?.length">
        <li
          v-for="(item, index) in list"
          :key="`item-${index}`"
          class="d-flex align-items-center"
          style="gap: 8px"
        >
          <router-link
            :to="item?.link ?? ''"
            v-if="index != list?.length - 1"
            class="fontsize-mini text-black text-nowrap"
          >
            {{ item?.title ?? "" }}
          </router-link>
          <p v-else class="fontsize-mini text-black m-0 line-clamp-1">
            {{ item?.title ?? "" }}
          </p>
          <span
            v-if="index != list?.length - 1"
            class="d-flex"
            style="transform: translateY(-1px)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="11"
              fill="currentColor"
              class="bi bi-chevron-double-left"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              />
              <path
                fill-rule="evenodd"
                d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              />
            </svg>
          </span>
        </li>
      </template>
    </ul>
  </section>
</template>
<!-- <script setup>
let props = defineProps({
  link1: String,
  titleLink1: String,
  link2: String,
  titleLink2: String,

  list: {
    type: Array,
    default: [],
  },
});
</script> -->
<script>
export default {
  name: "PagesPath",
  props: {
    list: {
      type: Array,
      default: [],
    },
    isHome: {
      type: Boolean,
      default: true,
    },
  },
  //   methods: {
  //     backLink() {
  //       history.back();
  //     },
  //   },
};
</script>
<style scoped>
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.content-pagePath {
  border-radius: 20px;
  padding: 14px 24px;
  gap: 8px;
}
.pages-path li {
  list-style-type: none;
}
.pages-path a.link {
  vertical-align: text-top;
  color: white;
}

path {
  /*stroke: white;*/
}

#backPageArrow {
  position: relative;
  left: 16px;
  display: none;
}
@media (max-width: 1023px) {
  .bread-crumb-text-overflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
@media (max-width: 768px) {
  #backPageArrow {
    display: unset;
  }
}
</style>
